import SitesTable from './SitesTable'

export default SitesTable
